/*
 * Atomz cart - add to cart, from anywhere, opens the drawer.
 *
 * The shop was on Dawn's "notification" cart: an add dropped a small card
 * under the header for a moment and the shopper was left where they were, with
 * no view of what is in the bag and no route to checkout that did not mean
 * leaving the page they were shopping. The theme is on the drawer now, which
 * Dawn already ships, and this is the three things that were left over.
 *
 * ONE. The header's cart button is the theme's own, not Dawn's. The drawer
 * binds itself to #cart-icon-bubble, and CartDrawer.renderContents also writes
 * the cart-icon-bubble section's markup INTO whatever carries that id after
 * every add -- so borrowing the id would have swapped this shop's bag icon for
 * Dawn's on the first add to cart. The button is opened from here instead.
 *
 * TWO. Which leaves the count. Dawn's own bubble updates because Dawn replaces
 * it wholesale; this one is refreshed from /cart.js, on Dawn's own cartUpdate
 * event where that fires and after any add this file handles itself.
 *
 * THREE. Dawn only intercepts the forms it knows about. A plain
 * <form action="/cart/add"> anywhere else on the page -- the Atomz card's own
 * add button is one, when the app is configured to draw it -- does a full page
 * POST and lands the shopper on /cart. Those are posted to /cart/add.js here
 * and end in the drawer like everything else.
 *
 * FAILURE MODE: no drawer on the page and the button is the link it always
 * was, the forms submit the way they always did, and nothing here runs.
 */
(function () {
  'use strict';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function openDrawer(trigger) {
    var d = drawer();
    if (!d || typeof d.open !== 'function') return false;
    d.open(trigger);
    return true;
  }

  /* ------------------------------------------------------------- the count */

  function paintCount(n) {
    var el = document.querySelector('[data-az-cart-count]');
    if (!el) return;
    el.textContent = n > 0 ? String(n) : '';
    el.hidden = !(n > 0);
  }

  function refreshCount() {
    if (!window.fetch) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paintCount(c.item_count); })
      .catch(function () { /* the server-rendered count stands */ });
  }

  /* ---------------------------------------------------------- forms Dawn misses */

  /*
   * Dawn's product-form.js binds to the forms it rendered. Anything else that
   * posts to /cart/add is a full navigation, so it is caught here at the
   * document, in the capture phase, ahead of a handler the page may have bound
   * to the form itself.
   */
  function isPlainAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return false;
    // Dawn wraps its own in <product-form>, which already does this properly.
    return !form.closest('product-form');
  }

  function submitAdd(form) {
    var body = new FormData(form);
    // Ask for the drawer's section back in the same round trip, the way Dawn's
    // own form does, so the drawer opens with this item already in it.
    var d = drawer();
    if (d) body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: body,
      credentials: 'same-origin',
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (!state || state.status) return;          // a 4xx carries `status`
        if (d && state.sections && typeof d.renderContents === 'function') {
          d.renderContents(state);
        } else {
          openDrawer(null);
        }
        refreshCount();
      })
      .catch(function () { form.submit(); });        // let the browser do it
  }

  document.addEventListener('submit', function (e) {
    if (!window.fetch || !drawer()) return;
    if (!isPlainAddForm(e.target)) return;
    e.preventDefault();
    submitAdd(e.target);
  }, true);

  /* ------------------------------------------------------------- the button */

  function init() {
    var btn = document.querySelector('[data-az-cart]');
    if (btn && drawer()) {
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.addEventListener('click', function (e) {
        if (openDrawer(btn)) e.preventDefault();
      });
    }

    /* Dawn publishes this after its own adds. pubsub.js and constants.js are
       classic scripts, so both are globals where Dawn has loaded them. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
    }

    // The count is server-rendered and this page may have come from the back
    // button, which serves it from the bfcache with a stale number in it.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshCount();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
